export class AutoplayApplicationService {
    constructor(autoplayRepository, dateGateway) {
        this.autoplayRepository = autoplayRepository;
        this.dateGateway = dateGateway;
    }
    hasAutoplay() {
        return this.autoplayRepository.hasAutoplay();
    }
    isTimeForNextCleavage() {
        return Promise.all([
            this.autoplayRepository.retrieveNextAutoPlayDate(),
            this.dateGateway.retrieveCurrentDate()
        ])
            .then(([nextAutoplayDate, currentDate]) => Promise.resolve(currentDate >= nextAutoplayDate))
            .catch(error => Promise.reject(error));
    }
    configureNextAutoPlay(autoplayMinutes) {
        return autoplayMinutes === 0
            ? this.onDisableAutoplay(autoplayMinutes)
            : this.dateGateway.retrieveCurrentDate()
                .then(currentDate => autoplayMinutes
                ? this.onAutoplayMinutes(currentDate, autoplayMinutes)
                : this.onNoAutoplayMinutes(currentDate))
                .catch(error => Promise.reject(error));
    }
    onDisableAutoplay(autoplayMinutes) {
        return Promise.all([
            this.autoplayRepository.configureAutoplayInterval(autoplayMinutes),
            this.autoplayRepository.configureNextAutoPlay(null)
        ])
            .then(results => Promise.resolve())
            .catch(error => Promise.reject(error));
    }
    onAutoplayMinutes(currentDate, autoplayMinutes) {
        return Promise.all([
            this.autoplayRepository.configureNextAutoPlay(this.addMinutes(new Date(currentDate), autoplayMinutes)),
            this.autoplayRepository.configureAutoplayInterval(autoplayMinutes)
        ])
            .then(results => Promise.resolve())
            .catch(error => Promise.reject(error));
    }
    onNoAutoplayMinutes(currentDate) {
        return this.autoplayRepository.retreiveAutoplayInterval()
            .then(autoplayInterval => this.autoplayRepository.configureNextAutoPlay(this.addMinutes(new Date(currentDate), autoplayInterval)))
            .catch(error => Promise.reject(error));
    }
    addMinutes(date, minutes) {
        date.setMinutes(date.getMinutes() + minutes);
        return date;
    }
}
